module.exports = __webpack_public_path__ + "img/wp-icon.509d79e9.svg";